import { Button, Stack, Tooltip } from '@mui/material';
import CollapseIcon from '@/public/icons/collapse.svg';
import ExpandIcon from '@/public/icons/expand.svg';
import CloseIcon from '@/public/icons/close_black.svg';
import React, { PropsWithChildren } from 'react';

export type HeaderButtonBoxProps = PropsWithChildren<{
  isExpandable?: boolean; // 모달 크기 확장 기능 사용 여부
  isExpand?: boolean;
  handleClickExpandButton: () => void;
  handleClickCloseButton: () => void;
  isCloseButtonDisabled?: boolean;
}>;

const HeaderButtonBox = (props: HeaderButtonBoxProps) => {
  const {
    isExpandable,
    isExpand,
    handleClickExpandButton,
    handleClickCloseButton,
    isCloseButtonDisabled,
    children,
  } = props;

  return (
    <Stack
      direction={'row'}
      justifyContent={'flex-end'}
      alignItems={'center'}
      className={'button-box'}
      sx={{ button: { padding: '6px' } }}
    >
      {children}
      {isExpandable && (
        <Tooltip
          title={isExpand ? '축소해서 보기' : '확장해서 보기'}
          placement="top"
          arrow
          // offset -8 로 말풍선이 버튼 상단을 덮는데, 기본값(interactive)은
          // popper 가 pointer-events:auto 라 그 지점의 클릭을 툴팁이 삼킨다
          disableInteractive
          slotProps={{
            tooltip: {
              sx: { backgroundColor: 'black', color: 'white' },
            },
            arrow: { sx: { color: 'var(--dk-text, black)' } },
            popper: {
              modifiers: [{ name: 'offset', options: { offset: [0, -8] } }],
            },
          }}
        >
          <Button className={'expand'} onClick={handleClickExpandButton}>
            {isExpand ? (
              <CollapseIcon width={'24px'} height={'24px'} />
            ) : (
              <ExpandIcon width={'24px'} height={'24px'} />
            )}
          </Button>
        </Tooltip>
      )}
      <Button
        className={'close'}
        onClick={handleClickCloseButton}
        disabled={isCloseButtonDisabled}
        sx={{
          '&:disabled': {
            opacity: 0.5,
            cursor: 'not-allowed',
          },
        }}
      >
        <CloseIcon width={'24px'} height={'24px'} />
      </Button>
    </Stack>
  );
};
export default HeaderButtonBox;
